module.exports = require("@ember/component");